module.exports = __webpack_public_path__ + "static/media/feature-ai.e28a80e3.png";